import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';

let emptyObject = {
    number: '',
    date: null,
    invalidationReason: ''
};

const InvalidateExtractedSubjectsDialog = (props) => {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [step, setStep] = useState('START');
    const [errorMessage, setErrorMessage] = useState(null);

    const toast = useRef(null);
    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        if (step === 'SUCCESS') {
            if (typeof props.afterSave === 'function') {
                props.afterSave();
            }
        }
        setDialogVisible(false);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: emptyObject,
        validate: (data) => {
            let errors = {};

            /*if (!data.number) {
                errors.number = translatedMessage('form.error.registrationNumber.required');
            }
            if (!data.date) {
                errors.date = translatedMessage('form.error.date.required');
            }*/
            if (!data.invalidationReason) {
                errors.invalidationReason = translatedMessage('form.error.invalidationReason.required');
            }
            return errors;
        },
        onSubmit: (data) => {
            invalidateExtractedSubjects(data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const invalidateExtractedSubjects = (data) => {
        competitionService
            .invalidateExtractedSubjects(props.competition?.id, data)
            .then(() => {
                setStep('SUCCESS');
                //            toast.current.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
                formik.resetForm();
            })
            .catch((error) => {
                setStep('ERROR');
                setErrorMessage(translatedMessage(error));
                toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
            });
    };

    const subjectDialogFooter = (
        <>
            {step === 'START' && <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            {step === 'START' && <Button label={translatedMessage('competition.extractedSubjects.invalidate')} icon="pi pi-save" className="p-button-text" form="subject-form" type="submit" />}
            {step === 'ERROR' && <Button label={translatedMessage('generic.close')} icon="pi pi-save" className="p-button-text" onClick={hideDialog} />}
            {step === 'SUCCESS' && <Button label={translatedMessage('generic.close')} icon="pi pi-save" className="p-button-text" onClick={hideDialog} />}
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={dialogVisible} style={{ width: '600px' }} header={translatedMessage('competition.invalidateExtractSubjects.title')} modal className="p-fluid" footer={subjectDialogFooter} onHide={hideDialog}>
                <div className="w-full grid pcn-data-view-panel">
                    {step === 'START' && (
                        <>
                            <div className="col-1 flex align-items-center">
                                <Button icon="pi pi-exclamation-circle" className="p-button-rounded p-button-info p-button-text" />
                            </div>
                            <div className="col-11 flex align-items-center">
                                <div className="w-full grid pcn-data-view-panel">
                                    <div className="col-12 flex align-items-center">
                                        <b>{translatedMessage('competition.invalidateExtractSubjects.question')}</b>
                                    </div>
                                    <div className="col-12 flex align-items-center">{translatedMessage('competition.invalidateExtractSubjects.content')}</div>
                                </div>
                            </div>
                            <div className="col-12 flex align-items-center">
                                <form id="subject-form" onSubmit={formik.handleSubmit} className="width-100">
                                    <div className="grid width-100">
                                        {/*<div className="col-6">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText type="text" id="number" name="number" value={formik.values.number} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('number') })} />
                                                    <label htmlFor="number" className={classNames({ 'p-error': isFormFieldValid('number') })}>
                                                        {translatedMessage('application.registrationNumber')} *
                                                    </label>
                                                </span>
                                            </div>
                                            {getFormErrorMessage('number')}
                                        </div>
                                        <div className="col-6">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <Calendar id="date" name="date" value={formik.values.date} onChange={formik.handleChange} dateFormat="dd-mm-yy" className={classNames({ 'p-invalid': isFormFieldValid('date') })} />
                                                    <label htmlFor="date" className={classNames({ 'p-error': isFormFieldValid('date') })}>
                                                        {translatedMessage('holiday.date')} *
                                                    </label>
                                                </span>
                                            </div>
                                            {getFormErrorMessage('date')}
                                        </div>*/}
                                        <div className="col-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputTextarea
                                                        type="text"
                                                        id="invalidationReason"
                                                        name="invalidationReason"
                                                        value={formik.values.invalidationReason}
                                                        onChange={formik.handleChange}
                                                        className={classNames({ 'p-invalid': isFormFieldValid('invalidationReason') })}
                                                        rows={5}
                                                    />
                                                    <label htmlFor="invalidationReason" className={classNames({ 'p-error': isFormFieldValid('invalidationReason') })}>
                                                        {translatedMessage('recruitment.plan.invalidationReason')} *
                                                    </label>
                                                </span>
                                            </div>
                                            {getFormErrorMessage('invalidationReason')}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                    {step === 'ERROR' && (
                        <div className="col-12 flex align-items-center">
                            <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text" />
                            {errorMessage}
                        </div>
                    )}
                    {step === 'SUCCESS' && (
                        <>
                            <div className="col-12 flex align-items-center">
                                <Button icon="pi pi-check" className="p-button-rounded p-button-text" />
                                {translatedMessage('competition.invalidateExtractSubjects.success.message')}
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default InvalidateExtractedSubjectsDialog;
